export class SIQAttachmentSheetTheme {
  backgroundColor = "null";
  overlayColor = "null";
  tintColor = "null";
  separatorColor = "null";
}
//# sourceMappingURL=SIQAttachmentSheetTheme.js.map